import axios from "axios";
import Swal from "sweetalert2";
import i18n from "../i18n";

const BASE_URL = import.meta.env.VITE_BASE_URL;

const instance = axios.create({
  baseURL: BASE_URL || "http://127.0.0.1:8000/api",
  headers: { "Content-Type": "application/json" },
  timeout: 300000, // 5 minutes
});

let isAlertActive = false; // prevent multiple alerts

// Request interceptor
instance.interceptors.request.use(
  (config) => {
    // Attach token
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

   // Current application language
    const language = i18n?.language || localStorage.getItem("app_language") || "en";
    const currency = localStorage.getItem("currency_code") || "SAR";

    if (config.headers) {
      config.headers["Accept-Language"] = language;
      config.headers["X-Currency"] = currency;
    }


    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    if (
      response &&
      response.status === 401 &&
      response.statusText === "Unauthorized" &&
      !isAlertActive
    ) {
      isAlertActive = true; // prevent duplicate alerts
      localStorage.removeItem("token");

      Swal.fire({
        icon: "error",
        title: "Session Expired",
        text: "Your session has expired. Please login again.",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(() => {
        isAlertActive = false;
        window.location.href = "/sign-in"; // redirect to login
      });
    }

    return Promise.reject(error);
  }
);

export default instance;
